import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=dea7f606&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dea7f606')) {
      api.createRecord('dea7f606', component.options)
    } else {
      api.reload('dea7f606', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=dea7f606&", function () {
      api.rerender('dea7f606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l8Ra0XPppbwW/JS/videoIframe.vue"
export default component.exports